:host {
  --input-border-radius: 3px;
  --input-border-style: solid;
  color: var(--text-primary);
}

.overral-container {
  display: flex;
  align-items: center;

  .input-container {
    padding: 0 !important;
    margin: 0 !important;
    position: relative;
    width: 100%;

    .label {
      position: absolute;
      left: 10px;
      top: 50%; 
      transform: translateY(-50%);
      pointer-events: none;
      color: var(--gray-400);
      font-size: 14px;
      transition: all 0.3s ease-in-out;
      font-family: "Lato";
      font-weight: 400;
      background-color: transparent;
      padding: 1px 4px;

      &:before {
        content: "";
        position: absolute;
        z-index: -1;
        width: 120%;
        display: block;
        left: -2px;
        height: 3px;
        bottom: 10px;
      }
    }

    .input {
      outline: none;
      // background: none;
      color: var(--gray-600);
      background-color: transparent;
      border: 1px solid var(--gray-400);
      border-radius: 4px;
      font-weight: 400;
      padding: 12px 0 12px 12px;
      width: 100%;
      transition: all 0.3s ease-in-out;
      font-family: "Lato";
      box-sizing: border-box;
    }

    .input:focus + .label {
      top: 3%;
      color: var(--gray-500);
      font-size: 12px;
      // background-color: var(--pure-white);
    }

    .open-label {
      position: absolute;
      left: 10px;
      top: 3%;
      transform: translateY(-50%);
      pointer-events: none;
      color: var(--gray-500);
      font-size: 12px;
      transition: all 0.3s ease-in-out;
      font-family: "Lato";
      font-weight: 400;
      // background-color: var(--pure-white);
      padding: 1px 2px;

      // &:before {
      //   content: "";
      //   position: absolute;
      //   z-index: -1;
      //   width: 100%;
      //   display: block;
      //   left: 0px;
      //   height: 3px;
      //   bottom: 10px;
      //   background-color: var(--label-bg-color, transparent);
      // }
    }
    .floating-label-bg {
      width: 100%;
      display: block;
      position: absolute;
      height: 4px;
      left: 0px;
      top: 6px;
      padding: 0 0px;
      z-index: -1;
    }

    .input-action {
      cursor: pointer;

      &:hover {
        --text-color: var(--text-secondary);
      }
    }
  }

  .invisible{
    visibility: hidden;
  }

  .search-button {
    background-color: var(--primary-main);
    color: white;
    font-size: 14px;
    font-weight: 600;
    padding: 17px 22px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    outline: none;
    border: 1px solid var(--primary-main);
    cursor: pointer;
    margin-left: -4px;
    z-index: 100;
    box-shadow: none;
  }
}

:host(.light) .input-container input {
  background-color: var(--pure-white);
}


:host([size="sm"]) .input-container {
  padding: 0;

  .input, .signet-input--sm {
    font-size: 13px;
    font-weight: 400;
    padding-top: 7px;
    padding-bottom: 7px;
  }

  slot::slotted(*) {
    font-size: 14px;
    font-weight: 400;
  }
}

:host([size="md"]) .input-container {
  padding: 0;

  .input, .signet-input--md {
    font-size: 15px;
    font-weight: 400;
    padding-top: 12px;
    padding-bottom: 12px;
  }

  slot::slotted(*) {
    font-size: 16px;
    font-weight: 400;
  }
}

:host([size="lg"]) .input-container {
  padding: 0;

  .input, .signet-input--lg {
    font-size: 17px;
    font-weight: 400;
    padding-top: 14px;
    padding-bottom: 14px;
  }

  slot::slotted(*) {
    font-size: 18px;
    font-weight: 400;
  }
}

:host([success]) {
  .input-container .input {
    border-color: #198038;
  }
}

:host([error]) {
  .input-container .input {
    border-color: #da1e28;
    box-shadow: 0 0 0 0.25rem rgba(#ef4444, 25%);
  }
}

:host([readonly]) .input {
  .input-container {
    cursor: initial;
    background-color: var(--gray-50) !important;
    border-color: var(--gray-400) !important;
    opacity: 1 !important;
  }
}

.input:disabled {
  background-color: var(--gray-50) !important;
  color: var(--gray-400) !important;
  cursor: not-allowed;
}
.open-label {
  color: var(--gray-400);
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.input-container .open-label,
.input:focus + .label {
  color: rgba(0, 0, 0, 0.6);
}
